export default "__VITE_ASSET__DAJyRGmt__"